module.exports = __webpack_public_path__ + "img/alerts-3.a007cb76.gif";